import React from "react";

import "../../../styles/About/Route/Graduation.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarDays, faTimes } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";

const Graduation = ({ darkTheme }) => {
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate(-1); // Navigate to the previous page
  };
  return (
    <>
      <div className="graduation">
        <div className="graduation__container">
          <div className="graduation__header">
            <h2 className="graduation__number">
              0<span>4</span>
            </h2>
            <h1
              data-aos="fade-down"
              data-aos-offset="0"
              style={{
                display: "inline-block",
                paddingRight: "0.1em", // Add a bit of padding to prevent clipping
                color: darkTheme ? "white" : "transparent",
                background: darkTheme
                  ? "none"
                  : "linear-gradient(167deg, #79a6d2 21%, #ffb3e6)",
                WebkitBackgroundClip: darkTheme ? "none" : "text",
                WebkitTextFillColor: darkTheme ? "white" : "transparent",
              }}
            >
              E<span>ngineering</span>.
            </h1>
            <button
              className="experience__close-button"
              onClick={handleGoBack}
              style={{
                background: "none",
                border: "none",
                color: darkTheme ? "white" : "black",
                cursor: "pointer",
                position: "absolute",
                top: "2px",
                right: "20px",
                padding: "10px", // Increase padding for better clickability
              }}
            >
              <FontAwesomeIcon icon={faTimes} size="xl" />
            </button>
          </div>
          <div
            className="graduation__description"
            style={{ color: darkTheme ? "white" : "black" }}
          >
            <h1>Aligarh Muslim University</h1>
            <h2>
              <FontAwesomeIcon
                icon={faCalendarDays}
                className="internships__calendar"
                style={{
                  color: darkTheme ? "#00ffff" : "#ff6347",
                }}
              />
              &nbsp;&nbsp;05/08/2016 - 31/07/2022
            </h2>
            <p
              style={{
                color: darkTheme ? "white" : "black",
                fontWeight: darkTheme ? "none" : 500,
              }}
            >
              I hold a Master's degree in Computer Science and Applications from
              Aligarh Muslim University, earned between 2019 and 2022. Prior to
              that, I completed my Bachelor of Science (Honors) in Computer
              Science at the same institution from 2016 to 2019. These academic
              pursuits have equipped me with a strong foundation in computer
              science principles, enabling me to excel in my career as a data
              scientist.
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default Graduation;
